import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-gradient-progress-bar',
  templateUrl: './gradient-progress-bar.component.html',
  styleUrls: ['./gradient-progress-bar.component.scss']
})
export class GradientProgressBarComponent implements OnInit {
  @Input() currentValue;
  @Input() maxValue;
  @Input() showLabel: boolean = true;
  @Input() height: string = '20px';
  @Input() borderRadius: string = '10px';

  constructor() { }

  ngOnInit(): void {
    // Ensure values are within valid range
    if (this.currentValue < 1) {
      this.currentValue = 1;
    }
    if (this.currentValue > this.maxValue) {
      this.currentValue = this.maxValue;
    }
  }

  get progressPercentage(): number {
    // If both values are 0, return 0% (empty progress bar)
    if (this.currentValue === 0 && this.maxValue === 0) {
      return 0;
    }
    return Math.min(100, Math.max(0, ((this.currentValue) / (this.maxValue)) * 100));
  }

  get progressStyle(): { [key: string]: string } {
    return {
      width: `${this.progressPercentage}%`,
      height: this.height,
      borderRadius: this.borderRadius
    };
  }

  get containerStyle(): { [key: string]: string } {
    return {
      height: this.height,
      borderRadius: this.borderRadius
    };
  }

  get labelStyle(): { [key: string]: string } {
    const isLabelCovered = this.progressPercentage > 80; // Label is covered when progress is > 80%
    return {
      color: isLabelCovered ? 'white' : 'var(--text-color, #333)',
      fontWeight: 'bold',
      fontSize: '10px',
      textShadow: isLabelCovered ? '0 1px 2px rgba(0,0,0,0.3)' : 'none',
      zIndex: '10'
    };
  }

  get shouldShowLabel(): boolean {
    return this.showLabel && this.maxValue > 0 && this.currentValue > 0;
  }
}
